import { render, staticRenderFns } from "./preview.vue?vue&type=template&id=d1b116ce"
import script from "./preview.vue?vue&type=script&lang=js"
export * from "./preview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d1b116ce')) {
      api.createRecord('d1b116ce', component.options)
    } else {
      api.reload('d1b116ce', component.options)
    }
    module.hot.accept("./preview.vue?vue&type=template&id=d1b116ce", function () {
      api.rerender('d1b116ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Pygame/components/preview.vue"
export default component.exports